export const CARD_DIMENSIONS = { width: '178px' };
export const IMAGE_DIMENSIONS = '48px';
export const ICON_BUTTON_DIMENSIONS = 40;
export const ICON_SIZE = 20;
export const LINEAR_PROGRESS_WIDTH = '420px';
